import React from "react";
import PropTypes from "prop-types";



const Loader = ({ message = "" }) => {
    return (
        <div
            className="fixed inset-0 flex flex-col items-center justify-center bg-black/40 backdrop-blur-sm space-y-4"
            style={{
                zIndex: 99999, // 🧱 ensures it’s above all modals or dialogs
            }}
        >
            {/* Spinner */}
            <div className="w-14 h-14 border-4 border-white border-t-transparent rounded-full animate-spin"></div>

            {/* Message */}
            {message && (
                <p className="text-white text-sm font-medium text-center px-4">
                    {message}
                </p>
            )}
        </div>
    );
};
Loader.propTypes = {
    message: PropTypes.string,
};


export default Loader;
